import { toast } from 'react-toastify';

class Notify {
  success(text: string) {
    toast.success(text, {
      position: 'top-right',
    });
  }
  error(text: string) {
    toast.error(text, {
      position: 'top-right',
    });
  }
  warn(text: string) {
    toast.error(text, {
      position: 'top-right',
    });
  }
  info(text: string) {
    toast.error(text, {
      position: 'top-right',
    });
  }
}

export const notify = new Notify();
